var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"button-outline-light mr-3",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.onSsoSubmit()}}},[_vm._v("Acceder")])])
}
var staticRenderFns = []

export { render, staticRenderFns }